import React from 'react'
import { Alert, AlertIcon, Box, Link, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface OriginCacheControlInfoProps {
  enabled?: boolean
}

const OriginCacheControlInfo: React.FC<OriginCacheControlInfoProps> = ({ enabled }) => {
  const { t } = useTranslation()

  if (!enabled) {
    return null
  }

  return (
    <Alert status="info" mb={4}>
      <AlertIcon />
      <Box>
        <Text display="inline">
          {t(
            'origin_cache_control_enabled',
            'Origin-based cache control is enabled for this URL endpoint.',
          )}{' '}
        </Text>
        <Link href="https://imagekit.io/docs/cdn-caching-and-purging#advanced-caching-configuration" isExternal whiteSpace="nowrap">
          {t('read_more', 'Read More')}
        </Link>
      </Box>
    </Alert>
  )
}

export default OriginCacheControlInfo
